import React, { useEffect, useState, useRef} from "react";
import "./sidebarbooking.css";
import { convertISOToDDMMYYYY, DateFormatter, formatDate, formatDateByLocaleShort, getCurrency } from "../../../helper/Formatter";
import moment from "moment";


const SidebarBooking = (props) => {
  let totalPrice = props.sameBooking?.map((item => item?.actualcost)).reduce((a, b) => a + b, 0);


    return (
    <div className="booking_card_sidebar_right">
      <div className="date-section">
        <span className="label">Dates :</span>
        <span className="value">
          {/* to modify */}
          {props.bookingInfo?.checkin ?  formatDate(props?.bookingInfo?.checkin) : ""} <span className="fw-bold">-</span> {props.bookingInfo?.checkout ? formatDate(props.bookingInfo?.checkout) : "" }
        </span>
      </div>
      <div className="night-section">
        <span className="label">Nights :</span>
        {/* //to Modify */}
        <span className="value">{(new Date(props.bookingInfo?.checkout) - new Date(props.bookingInfo?.checkin))/ (1000 * 3600 * 24)}</span>
      </div>

      {/*  repeated loop */}

      {props?.sameBooking?.length > 0 && props?.sameBooking.map((booking, index) => {
        console.log(booking,"bookinga")
        return (
          <div key={index} className="room-details">
          <div className="room-info">
            <span>
              {/* Room {index + 1}: */}
              {booking.roomName}</span>
            {/* <button className="remove-button">✖</button> */}
          </div>
          <div className="guests">
            <span>
              {booking.adults} Adults, {booking.childrens} Children
            </span>
          </div>
          <div className="room-count">
            {booking.room} Room{booking.room > 1 ? "s" : ""}
          </div>
          <div className="price">
            <span>  {getCurrency()}&nbsp;{booking.actualcost === 0 ? 0 : booking.actualcost.toFixed(2)}</span>
          </div>
        </div>
        )
      })}

      {/*  repeated loop */}

      <div className="total-section">
        <span>Total</span>
        {/* to Modify */}
        <span className="total-amount">  {getCurrency()}&nbsp;{totalPrice === 0 ? 0 : totalPrice.toFixed(2)}
          {/* {props?.bookingInfo?.bookingdetail?.actualcost} */}
          </span>
      </div>
      {/* <p className="my-0">(exclude tax)</p> */}
      <button className="book-button" onClick={props.onBook}>Continue</button>
    </div>
  );
};

export default SidebarBooking;
